export default {
    computed: {
        favorites() {
            return this.$store.getters.getFavorites
        },
        favoritesCount() {
            return this.favorites.length
        }
    },
    // language=Vue
    template: `
          <span v-if="favoritesCount > 0">{{favoritesCount}}</span>
        `
}